import { IForm } from 'core-components/classes/models/IForm'
import { IDataProviderFilter, Logic } from 'core-components/types'
import { filterOptions, IDataTableSettings } from 'src/core/classes/models/IDataTable'
import Logger from 'src/core/utils/Logger'

export const createTableFilter = (
  settings?: IDataTableSettings | null | undefined,
  aliases?: { [key: string]: string | string[] }
): IDataProviderFilter | IForm => {
  const aliasMap = aliases || {}
  if (settings && settings.filterAvailable && settings.filters.length) {
    const result: IDataProviderFilter = {
      logic: Logic.AND,
      filters: [],
    }

    settings.filters.forEach((item) => {
      let fields: string[]
      let count = 1
      if (Array.isArray(aliasMap[item.field])) {
        count = aliasMap[item.field].length
        fields = aliasMap[item.field] as string[]
      } else if (aliasMap[item.field]) {
        fields = [aliasMap[item.field]] as string[]
      } else {
        fields = [item.field]
      }

      let filters = result.filters
      if (count > 1) {
        const filter = {
          logic: Logic.OR,
          filters: [],
        }
        result.filters.push(filter)
        filters = filter.filters
      }
      fields.forEach((field) => {
        const operator = filterOptions.find((i) => i.operator === item.operator)
        if (operator) {
          filters.push({
            field,
            operator: operator.operator,
            value: item.value,
          } as any)
        } else {
          Logger.error('operator not found:', item.operator)
        }
      })
    })
    return result
  }
  return {}
}
